export default {
  教学数据: '教學數據',
  学科管理: '學科管理',
  班级管理: '班級管理',
  教学管理: '教學管理',
  在读: '在讀',
  已毕业: '已畢業',
  学生数据: '學生數據',
  新增班级: '新增班級',
  编辑班级: '編輯班級',
  删除所有学生: '刪除所有學生',
  学生数据显示设置: '學生數據顯示設置',
  更多: '更多',
  导入座位号: '導入座位號',
  导出座位号: '導出座位號',
  批量导出学生: '批量導出學生',
  批量导入调班学生: '批量導入調班學生',
  批量导入学生: '批量導入學生',
  新增学生: '新增學生',
  操作: '操作',
  调班: '調班',
  编辑学生: '編輯學生',
  入学年份: '入學年份',
  请选择学生入学年份: '請選擇學生入學年份',
  姓名: '姓名',
  请输入学生姓名: '請輸入學生姓名',
  学号: '學號',
  请输入学生的学号: '請輸入學生的學號',
  借读生: '借讀生',
  请选择借读生状态: '請選擇借讀生狀態',
  密码: '密碼',
  请输入密码: '請輸入密碼',
  座位号: '座位號',
  请输入座位号: '請輸入座位號',
  账号: '賬號',
  性别: '性别',
  请选择学生的性别: '請選擇學生的性別',
  身份证号: '身份證號',
  请填写证件号码: '請填寫證件號碼',
  请填写: '請填寫',
  内容: '内容',
  编辑: '編輯',
  删除: '刪除',
  取消选择: '取消選擇',
  已选择: '已選擇',
  批量刪除: '批量刪除',
  班级学习进度: '班級學習進度',
  没有章节数据: '沒有章節數據',
  '请输入学生姓名/学号': '請輸入學生姓名/學號',
  '您确定要删除此学生吗？': '您確定要刪除此學生嗎？',
  '您确定要删除此班级吗？': '您確定要刪除此班級嗎？',
  新增教师: '新增教師',
  批量导入教师: '批量導入教師',
  全部解锁: '全部解鎖',
  数据权限: '數據權限',
  请输入姓名或手机号: '請輸入姓名或手機號',
  手机号: '手機號',
  职称: '職稱',
  查看: '查看',
  重置密码: '重置密碼',
  离校: '離校',
  锁定: '鎖定',
  开启: '開啓',
  编辑教师: '編輯教師',
  教师姓名: '教師姓名',
  证件类型: '證件類型',
  证件号码: '證件號碼',
  考试学校管理: '考試學校管理',
  批量导入: '批量導入',
  新增学校: '新增學校',
  编辑学校: '編輯學校',
  请输入学校名: '請輸入學校名稱',
  学校名称: '學校名稱',
  用户名: '使用者名稱',
  修改: '修改',
  批量导出: '批量導出',
  学校编码: '學校編碼',
  修改密码: '修改密碼',
  报名设置: '報名設定',
  报名场次设置: '報名場次設定',
  报名时间设置: '報名時間設定',
  报名科目设置: '報名科目設置',
  所属学年: '所屬學年',
  日期及场次: '日期及場次',
  报名开始时间: '報名開始時間',
  报名结束时间: '報名結束時間',
  状态: '狀態',
  科目中文名称: '科目中文名稱',
  科目英文名称: '科目英文名稱',
  报名学生管理: '報名學生管理',
  清除学生: '清除學生',
  学科: '學科',
  学校: '學校',
  班别: '班別',
  班号: '班號',
  科目: '科目',
  考号: '考號',
  复制: '複製',
  准考证管理: '准考證管理',
  新增准考证批次: '新增准考證批次',
  语言版本: '語言版本',
  学生下载地址: '學生下載地址',
  准考证批次名称: '准考證批次名稱',
  下载开始时间: '下載開始時間',
  下载结束时间: '下載結束時間',
  准考证模板: '准考證模板',
  准考证数量: '准考證數量',
  上传模板: '上傳模板',
  下载准考证: '下載准考證',
  考生姓名: '考生姓名',
  报考科目: '報考科目',
  考试地点: '考試地點',
  日期时间: '日期時間',
  新增报名场次: '新增報名場次',
  清空数据: '清空數據',
  准考证下载: '准考證下載',
  序号: '序號',
  关闭: '關閉',
  '您确定要删除此教师吗？': '您確定要刪除此教師嗎？',
  '你确定要删除当前教师吗？删除后将自动退出!':
    '你確定要刪除當前教師嗎？刪除後將自動退出!',
  教师管理: '教師管理'
}
